import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import c from 'classnames';

import PendingItem from './components/PendingItem';
import SuccessItem from './components/SuccessItem';
import FailedItem from './components/FailedItem';

import './_batchMessageStatus.scss';

const BatchMessageStatus = () => {
  const { status: { list } } = useSelector(s => s.batchMessage);
  const batchMessageStatusClass = c('batchMessageStatus', { 'hide': isEmpty(list) });

  const renderCorrectStatusItem = item => {
    switch (item.status) {
      case 'pending': {
        return <PendingItem key={item.id} item={item} />;
      }
      case 'running': {
        return <PendingItem key={item.id} item={item} />;
      }
      case 'completed': {
        return <SuccessItem key={item.id} item={item} />;
      }
      case 'failed': {
        return <FailedItem key={item.id} item={item} />;
      }
    }
  };

  return (
    <div className={batchMessageStatusClass}>
      {list.map(item => {

        return renderCorrectStatusItem(item);
      })}
    </div>
  );
};

export default BatchMessageStatus;
